import { useFetchFromServer } from '../../../api/fetchHook'
import { useQuery } from 'react-query'
import { ScanDetails } from '../../../../../shared/src/data/scanDetails'
import { RoleHierarchy } from '../../../../../shared/src/data/roleHierarchy/roleHierarchy'
import { scanMetadataKeyFactory } from './scanMetadataKeyFactory'
import { parseJSON } from 'date-fns'
import { serverRoutes } from '../../../layout/serverRoutes'
import { FileDetails } from '../../../../../shared/src/data/fileDetails'

export const useGetScansForHierarchy = (
  roleHierarchy?: RoleHierarchy,
  pending?: boolean,
) => {
  const { fetchJsonFromServer } = useFetchFromServer()
  return useQuery<ScanDetails[]>(
    scanMetadataKeyFactory.scansForRoleHierarchy(roleHierarchy),
    () => {
      return !roleHierarchy
        ? []
        : fetchJsonFromServer<ScanDetails[]>(
            pending
              ? serverRoutes.api.scansMetadata.pendingScansForHierarchy(
                  roleHierarchy,
                )
              : serverRoutes.api.scansMetadata.scansForHierarchy(roleHierarchy),
          )
    },
    {
      select: (scans: ScanDetails[]) =>
        scans.map<ScanDetails>((s) => ({
          ...s,
          creationTime: parseJSON(s.creationTime),
        })),
    },
  )
}

export const useGetFilesRelatedToScan = (uploadId?: string) => {
  const { fetchJsonFromServer } = useFetchFromServer()

  return useQuery<FileDetails[]>(
    scanMetadataKeyFactory.filesRelatedToScan(uploadId),
    () => {
      return !uploadId
        ? []
        : fetchJsonFromServer<FileDetails[]>(
            serverRoutes.api.scansMetadata.filesForScan(uploadId),
          )
    },
  )
}
